module.exports = __webpack_public_path__ + "static/media/desktop-icon-24-profile.b4b85306.svg";